export default "__VITE_ASSET__CFcaR55Z__"